import React from "react";
import { useRouteMatch } from "react-router-dom";
import { AppRouter } from "@MASTER";
import { useAuthority } from "@HOOKS";
import Invoice from "./invoices";
import Pods from "./pods";

const Invoices = () => {
  let { path } = useRouteMatch();

  return (
    <div className="app-definitions">
      {useAuthority("INVOICE") && (
        <AppRouter path={`${path}/invoice`} title="Faturalarım">
          <Invoice />
        </AppRouter>
      )}

      {useAuthority("PODS") && (
        <AppRouter path={`${path}/pods`} title="Tahsilatlı Gönderi Gelirleri">
          <Pods />
        </AppRouter>
      )}
    </div>
  );
};

export default Invoices;
